import pdfMake from 'pdfmake-thaifont-2/build/pdfmake'
import 'pdfmake-thaifont-2/build/vfs_fonts'
import React from 'react'
import dayjs from 'dayjs'
import _ from 'lodash'
import { text } from '@fortawesome/fontawesome-svg-core'

pdfMake.fonts = {
  AngsanaNew: {
    normal: 'AngsanaNew.ttf',
    bold: 'AngsanaNew_bold.ttf',
    italics: 'AngsanaNew.ttf',
    bolditalics: 'AngsanaNew.ttf',
  },
  Impac: {
    normal: 'impac.ttf',
    bold: 'impac.ttf',
    italics: 'impac.ttf',
    bolditalics: 'impac.ttf',
  },
  FontAwesome: {
    normal: 'FontAwesome_regular.ttf',
    bold: 'FontAwesome_regular.ttf',
    italics: 'FontAwesome_regular.ttf',
    bolditalics: 'FontAwesome_regular.ttf',
  },
}

const renderMapTime = (data, timeMap) => {
  const content = []
  _.map(timeMap, (time, index) => {
    let indexTime = false
    if (data?.length === 0) {
      return content.push([
        { text: time, style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
        { text: '', style: 'tableContent' },
      ])
    } else {
      //console.log('Time', time, index, data.length)
      _.map(data, (eachData, indexData) => {
        if (time === eachData?.Timer) {
          indexTime = true
          content.push([
            { text: eachData?.Timer || '', style: 'tableContent' },
            {
              text: eachData?.FeedWater['บ่อ 1'],
              style: 'tableContent',
            },
            {
              text: eachData?.FeedWater['บ่อ 2'],
              style: 'tableContent',
            },
            {
              text: eachData?.PressurePond['บ่อ 1'],
              style: 'tableContent',
            },
            {
              text: eachData?.PressurePond['บ่อ 2'],
              style: 'tableContent',
            },
            {
              text: eachData?.PressurePond['บ่อ 3'],
              style: 'tableContent',
            },
            {
              text: eachData?.pH1.น้ำเข้า,
              style: 'tableContent',
            },
            {
              text: eachData?.pH1.น้ำออก,
              style: 'tableContent',
            },
            {
              text: eachData?.pH2.น้ำเข้า,
              style: 'tableContent',
            },
            {
              text: eachData?.pH2.น้ำออก,
              style: 'tableContent',
            },
            {
              text: eachData?.temp1.น้ำเข้า,
              style: 'tableContent',
            },
            {
              text: eachData?.temp1.น้ำออก,
              style: 'tableContent',
            },
            {
              text: eachData?.temp2.น้ำเข้า,
              style: 'tableContent',
            },
            {
              text: eachData?.temp2.น้ำออก,
              style: 'tableContent',
            },
            {
              text: eachData?.GasQuality.CH4,
              style: 'tableContent',
            },
            {
              text: eachData?.GasQuality.CO2,
              style: 'tableContent',
            },
            {
              text: eachData?.GasQuality.O2,
              style: 'tableContent',
            },
            {
              text: eachData?.GasQuality.H2S,
              style: 'tableContent',
            },
            {
              text: eachData?.GasQuality.BAL,
              style: 'tableContent',
            },
            {
              text: eachData?.FlowGas,
              style: 'tableContent',
            },
            {
              text: eachData?.Pressure,
              style: 'tableContent',
            },
          ])
        } else if (indexTime === false && indexData + 1 === data?.length) {
          content.push([
            { text: time, style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
            { text: '', style: 'tableContent' },
          ])
          return content
        }
      })
    }
  })
  return content
}

const renderFooter = (data) => {
  const lessThanOrEqual = '\u2264'
  console.log('footer', data)
  const content = []
  if (data?.length === 0) {
    content.push(
      [
        {
          text: 'Gas Engines 1',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งก่อน',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าที่ผลิตได้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: 'Gas Engines 2',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งก่อน',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าที่ผลิตได้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งก่อน บ่อ 1',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},

        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งนี้ บ่อ 1',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบ บ่อ 1',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งก่อน บ่อ 2',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งนี้ บ่อ 2',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบ บ่อ 2',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซครั้งก่อน',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................Nm³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Nm³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซที่ใช้ผลิต',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Nm³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าเข้าระบบ บ่อ 1,2 รวม',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ปริมาณก๊าซที่เกิดต่อนํ้า 1 m³',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'กระแสไฟฟ้าที่ผลิตได้ต่อก๊าซ 1 m³',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Peak',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Off Peak',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Holiday',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า Gas Engines 1,2 รวม',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text: '................Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'Gas Engines 1 Run',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................hr.',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},

        {
          text: 'Gas Engines 2 Run',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text: '................hr.',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: 'หมายเหตุ......................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................',
          colSpan: 21,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ]
    )
    return content
  } else {
    content.push(
      [
        {
          text: 'Gas Engines 1',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งก่อน ',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งก่อน === '-' ||
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งก่อน === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งก่อน
                )} Kwh` || ' - Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งนี้ === '-' ||
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งนี้ === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าครั้งนี้
                )} Kwh` || ' - Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าที่ผลิตได้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าที่ผลิตได้ === '-' ||
            data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าที่ผลิตได้ === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines1?.มิเตอร์ไฟฟ้าที่ผลิตได้
                )} Kwh` || ' - Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: 'Gas Engines 2',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งก่อน',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งก่อน === '-' ||
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งก่อน === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งก่อน
                )} Kwh` || ' - Kwh',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งนี้ === '-' ||
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งนี้ === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าครั้งนี้
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ไฟฟ้าที่ผลิตได้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าที่ผลิตได้ === '-' ||
            data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าที่ผลิตได้ === ''
              ? '- Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GasEngines2?.มิเตอร์ไฟฟ้าที่ผลิตได้
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งก่อน บ่อ 1',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งก่อน === '-' ||
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งก่อน === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งก่อน
                )} m³` || ' - m³',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งนี้ บ่อ 1',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งนี้ === '-' ||
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งนี้ === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าครั้งนี้
                )} m³` || ' - m³',
          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบ บ่อ 1',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าระบบ === '-' ||
            data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าระบบ === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater1?.มิเตอร์น้ำป้อนเข้าระบบ
                )} m³` || ' - m³',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งก่อน บ่อ 2',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งก่อน === '-' ||
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งก่อน === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งก่อน
                )} m³` || ' - m³',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบครั้งนี้ บ่อ 2',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งนี้ === '-' ||
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งนี้ === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าครั้งนี้
                )} m³` || ' - m³',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าที่ป้อนเข้าระบบ บ่อ 2',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าระบบ === '-' ||
            data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าระบบ === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWater2?.มิเตอร์น้ำป้อนเข้าระบบ
                )} m³` || '. - m³',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซครั้งก่อน',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งก่อน === '-' ||
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งก่อน === ''
              ? ' - Nm³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งก่อน
                )} Nm³` || ' - Nm³',

          style: 'headerTable',
          alignment: 'left',
          colSpan: 2,
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซครั้งนี้',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งนี้ === '-' ||
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งนี้ === ''
              ? ' - Nm³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ครั้งนี้
                )} Nm³` || ' - Nm³',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์ก๊าซที่ใช้ผลิต',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ผลิต === '-' ||
            data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ผลิต === ''
              ? ' - Nm³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterGas?.มิเตอร์ก๊าซที่ใช้ผลิต
                )} Nm³` || ' - Nm³',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'มิเตอร์นํ้าเข้าระบบ บ่อ 1,2 รวม',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.MeterWaterTotal === '-' || data[0]?.MeterWaterTotal === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.MeterWaterTotal
                )} m³` || ' - m³',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ปริมาณก๊าซที่เกิดต่อนํ้า 1 m³',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GasGen === '-' || data[0]?.GasGen === ''
              ? ' - m³'
              : `${Intl.NumberFormat('en-US').format(data[0]?.GasGen)} m³` ||
                ' - m³',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'กระแสไฟฟ้าที่ผลิตได้ต่อก๊าซ 1 m³',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.PowerGenGas === '-' || data[0]?.PowerGenGas === ''
              ? ' - Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.PowerGenGas
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Peak',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.GenMeter?.Peak === '-' || data[0]?.GenMeter?.Peak === ''
              ? ' - Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GenMeter?.Peak
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Off Peak',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GenMeter?.['Off Peak'] === '-' ||
            data[0]?.GenMeter?.['Off Peak'] === ''
              ? ' - Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GenMeter?.['Off Peak']
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า ช่วง Holiday',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.GenMeter?.Holiday === '-' ||
            data[0]?.GenMeter?.Holiday === ''
              ? ' - Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GenMeter?.Holiday
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text: '',
          colSpan: 2,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'ผลิตไฟฟ้า Gas Engines 1,2 รวม',
          colSpan: 5,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {
          text:
            data[0]?.GenMeter['Total 1,2'] === '-' ||
            data[0]?.GenMeter['Total 1,2'] === ''
              ? ' - Kwh'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.GenMeter['Total 1,2']
                )} Kwh` || ' - Kwh',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'Gas Engines 1 Run',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.EnginesRun1 === '-' || data[0]?.EnginesRun1 === ''
              ? ' - hr.'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.EnginesRun1
                )} hr.` || ' - hr.',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {
          text: 'Gas Engines 2 Run',
          colSpan: 4,
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {
          text:
            data[0]?.EnginesRun2 === '-' || data[0]?.EnginesRun2 === ''
              ? ' - hr.'
              : `${Intl.NumberFormat('en-US').format(
                  data[0]?.EnginesRun2
                )} hr.` || ' - hr.',

          style: 'headerTable',
          colSpan: 2,
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
      ],
      [
        {
          text:
            data[0]?.comment === null
              ? 'หมายเหตุ......................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................'
              : `หมายเหตุ ${data[0]?.comment}`,
          colSpan: 21,
          margin: [0, 3],
          style: 'headerTable',
          alignment: 'left',
          border: [false, false, false, false],
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ]
    )
    return content
  }
}
const FM_BG_002 = async (form, formInput, subForm, system, date) => {
  const colors = '#dddddd'
  const timeMap = [
    '00.00',
    '02.00',
    '04.00',
    '06.00',
    '08.00',
    '10.00',
    '12.00',
    '14.00',
    '16.00',
    '18.00',
    '20.00',
    '22.00',
  ]
  //find data for map in table
  const dataPurifier = _.filter(formInput?.arr, {
    subForm_name: 'ค่าจากเซนเซอร์ต่างๆ',
  })
  const dataFooter = _.filter(formInput?.arr, {
    subForm_name: 'Gas Engines & บ่อน้ำ & ก๊าซ',
  })
  const TableBody = renderMapTime(dataPurifier, timeMap)
  const FooterBody = renderFooter(dataFooter)
  let docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [30, 90, 30, 0],
    defaultStyle: {
      font: 'AngsanaNew',
      fontSize: '12',
    },

    header: [
      {
        margin: [30, 20, 30, 0],
        table: {
          widths: ['23%', '48%', '14.5%', '14.1%'],
          body: [
            [
              {
                image: 'logo_imge',
                rowSpan: 2,
                fit: [30, 30],
                alignment: 'center',
                margin: [0, 2, 0, 0],
                border: [true, true, true, false],
              },
              {
                text: `${form?.name || ''} - (FM-BG-002)`,
                alignment: 'center',
                bold: true,
                fontSize: 16,
                margin: [0, 0, 0, -3],
                border: [true, true, true, false],
              },
              {
                text: `เอกสารหมายเลข: ${form?.docNo || '-'}  `,
                style: 'header',
                alignment: 'center',
                colSpan: 2,
                border: [true, true, true, true],
              },
              { text: '', border: [false, true, true, true] },
            ],
            [
              { text: '', border: [true, false, true, false] },
              {
                text: '',
                border: [true, false, true, false],
              },
              {
                text: `แก้ไขครั้งที่: 0${form?.editVersion || '-'}`,
                style: 'header',
                margin: [0, 2, 0, 0],
                alignment: 'center',
                border: [true, true, true, true],
              },
              {
                text: 'หน้าที่ : 1/1',
                style: 'header',
                margin: [0, 2, 0, 0],
                alignment: 'center',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: 'THAI TALLOW AND OIL CO.,LTD.',
                alignment: 'center',
                bold: true,
                font: 'Impac',
                fontSize: 12,
                border: [true, false, true, true],
              },
              {
                text: `วันที่ ${dayjs(date).format('DD เดือน MMMM พ.ศ. BBBB')}`,
                alignment: 'center',
                style: 'header',
                border: [true, false, true, true],
              },
              {
                text: `วันที่บังคับใช้ : ${
                  dayjs(form?.enforceDate).format('D MMM YYYY') || '-'
                }`,
                style: 'header',
                colSpan: 2,
                margin: [0, 2, 0, 0],
                alignment: 'center',
                border: [true, true, true, true],
              },
              {},
            ],
          ],
        },
      },
    ],
    info: {
      title: `${form?.name} ${dayjs(date).format('DD_MM_BBBB')}`,
      subject: '',
    },
    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '4.5%',
            '6%',
            '6%',
          ],
          body: [
            [
              //Row 1

              {
                text: '',
                border: [true, true, true, false],
                style: 'headerTable',
              },
              { text: 'ค่า Parameters', colSpan: 5, style: 'headerTable' },
              {},
              {},
              {},
              {},
              {
                text: 'pH',
                colSpan: 4,
                style: 'headerTable',
              },
              {},
              {},
              {},
              {
                text: 'อุณหภูมิ',
                colSpan: 4,
                style: 'headerTable',
              },
              {},
              {},
              {},
              { text: 'Gas Quality', colSpan: 5, style: 'headerTable' },
              {},
              {},
              {},
              {},
              { text: 'Flow gas', style: 'headerTable' },
              { text: 'Pressure', style: 'headerTable' },
            ],
            [
              //Row 2
              {
                text: '',
                border: [true, false, true, false],
                style: 'headerTable',
              },
              {
                text: 'อัตราการ Feed นํ้า',
                colSpan: 2,
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {},
              {
                text: 'Pressure Pond',
                colSpan: 3,
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {},
              {},
              {
                text: 'บ่อ 1',
                colSpan: 2,
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {},
              {
                text: 'บ่อ 2',
                colSpan: 2,
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {},
              {
                text: 'บ่อ 1',
                colSpan: 2,
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {},
              {
                text: 'บ่อ 2',
                colSpan: 2,
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {},
              {
                text: 'CH4',
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {
                text: 'CO2',
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {
                text: 'O2',
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {
                text: 'H2S',
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {
                text: 'BAL',
                rowSpan: 2,
                margin: [0, 2, 0, -2],
                style: 'headerTable',
              },
              {
                text: '',
                border: [false, false, false, false],
                style: 'headerTable',
              },
              {
                text: '',
                border: [true, true, true, false],
                style: 'headerTable',
              },
            ],
            [
              //Row 3
              {
                text: 'เวลา',
                style: 'headerTable',

                border: [true, false, true, false],
              },
              {
                text: '(m³/h)',
                colSpan: 2,

                style: 'headerTable',
                border: [true, false, true, true],
              },
              {},
              {
                text: '(mbar)',

                colSpan: 3,
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [0, 0, 0, -10],
                        alignment: 'right',
                        border: [false, false, false, false],
                      },
                      {
                        text: '1000',
                        margin: [-10, 0, 0, -10],
                        alignment: 'left',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [0, 0, 0, -10],
                        alignment: 'right',
                        border: [false, false, false, false],
                      },
                      {
                        text: '200',
                        margin: [-10, 0, 0, -10],
                        alignment: 'left',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
            ],
            [
              //Row 4
              {
                text: '',
                style: 'headerTable',
                border: [true, false, true, false],
              },
              {
                text: 'บ่อ 1',
                style: 'headerTable',
                border: [false, false, false, false],
              },
              {
                text: 'บ่อ 2',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'บ่อ 1',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'บ่อ 2',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'บ่อ 3',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าเข้า',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าออก',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าเข้า',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าออก',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าเข้า',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าออก',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าเข้า',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'นํ้าออก',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, true, true, false],
              },
              {
                text: 'm³/h',
                style: 'headerTable',
                border: [true, false, true, false],
              },
              {
                text: 'mbar',
                style: 'headerTable',
                border: [true, false, true, false],
              },
            ],
            [
              //Row 5
              {
                text: '',
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-5, -7, 0, -7],
                        border: [false, false, false, false],
                      },
                      {
                        text: '20',
                        margin: [-5, -8, 0, -7],
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
                rowSpan: 1,
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-5, -7, 0, -7],
                        border: [false, false, false, false],
                      },
                      {
                        text: '20',
                        margin: [-5, -8, 0, -7],
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
                rowSpan: 1,
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-7, -7, 0, -7],
                        border: [false, false, false, false],
                      },
                      {
                        text: '1.8',
                        margin: [-7, -8, 0, -7],
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-7, -7, 0, -7],
                        border: [false, false, false, false],
                      },
                      {
                        text: '1.8',
                        margin: [-7, -8, 0, -7],
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['50%', '50%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-7, -7, 0, -7],
                        border: [false, false, false, false],
                      },
                      {
                        text: '1.8',
                        margin: [-7, -8, 0, -7],
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                text: '3-6',
                margin: [-5, -4.5, 0, -7],
                style: 'headerTable',
                alignment: 'center',
                border: [true, false, true, true],
              },
              {
                text: '6.5-8.0',
                margin: [-5, -4.5, 0, -7],
                alignment: 'center',
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {
                text: '3-6',
                alignment: 'center',
                margin: [-5, -4.5, 0, -7],
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {
                text: '6.5-8.0',
                margin: [-5, -4.5, 0, -7],
                alignment: 'center',
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-10, -7, 0, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '  50 ํC',
                        margin: [-45, -8, 0, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAMAAAD8CC+4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGAUExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACpt4TUAAAB/dFJOUwDz1RIC+/kO4/0E2+Hv55n39Rx+as/J3wiFBhYMrdGzSArBOuU0oUBiIJOry7m3chB2tdfNGqcY2aPH63hkTnpSw7u96URQRp82PCYsqSJs01ZMpZtuFHxwHly/3TKvsYGdg0JKaItedMWNh5cu8TA4WFqJlSoo7T4kkWBmVI/e02X9AAAFvklEQVR42u3dZ1NWVxQG0FAsgCJKE6UoKiogqGABQcDesTfU2HvvJcn960lIMolR4PAhc/Puu9ZPeM48M/Duc/f54QcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoZWs3tQihWF48fZ5tEUORSj7am/1mnySKU/JlZdm0/bIohtY/Sj5tShxFcP2vkk/rFEj8kv80mH1lQibBbThflv3LI6lEtuheY/atYcHEdfTW8ux7mkQTteQN7dkMeqVTqJJPG5RPoUo+rVFE0bw8UpfNrl1IoWydPJ3N6bScAlnXVZclKJdUmJJfKM/SDAgrhmNDdYlHnlUdEVcAFcklz7Il9SsEVqiSL2hbUymw0i/55YHkktdsWy2w0vfx3MLUE1+4c6O8ApS8f3dyycsvVwis9G3cmVzy5V3r5FX6Lj5ML3ljwyKBFarkZcs2yCtCyWuSS960aa3ASt+dkwtST3xp9wl5lb7V29JL3nl1pcBK38Ge5JLvuX9cXgFKPnItueT7zqwSWOk73JZc8tqWzfIqfbtGmpOHptv3mqeUvsp5lNzQNEbJx5oNTYtV8jU3qgxNC2XHpSWGpsUq+d0fqwxNi1Xy+iWGpgUreUeVoWmhrKhfbGharJKfTS+5oWmMkt9cb2harJLv3Z5c8glD0wiu3E4u+Z7HhqYBVB/qqzI0LZTNLbXpQ9NT8gpRckNTJTc0DV3y8S2GpsVy6smB5KHpiKFpDFuSh6Z3hBVFh6Fp8fQYmhbPOUPT4jliaFo8ywxNi6d75qHpM+kEdd/QtHhavnvmPVckE1j9DFOVjjWyCWtkxj/jmrddFE9M/bP99HrumIAiaphjCX9Dq4zCGZ37UvsLKQXzIGHcMvzAfbhQXiVN2T48/iSqOMaTr78ecmkmimfp++DW1++QVxDzWAq3oO2gvIKYxz6ZrKbfHZogKtek75uo6zoqsCB2pH+PnjWOGrRHqfvZ9O9Vn3e/E1gQV24nf+qSdb6qFlgM8/jeJTvwxPLXKE692ZP+MeNZeQWx6sxU+tuZYz52iuL44w/JP9mc/CivKHW/OpH+wN6kLyKieNe9NHlh5Pnr8gpi5Zem9Fe4vrg2HcWzp2XJW+V+sXAqitbRweS67x/3k00UG84vT149ddNWmigWNbQn/2Rz47C8onjZVZd67tceGrtHsfXCQPLLHkP2V4Rx7Fzy49nt93wpEUVFf/JlyrKnNoOHMY9ntB+99qVEFKvTX+Dc88b64DAOp7/Q12eHcBjzeKZv8aVd8gpiHi/8LOjxOmMYK9JfANl9Yau8gqg+lHyZsu6WbYRhbE7fID64ydg9TN1/3p88dv/8Xl5RfLqffHd66oyxexSrXnemv/hkQWEY7z+nXqa0oDCQlQ+GU+vePCmuME68fZ74n7usAlm7qTfl0AckFcv1ZXPfnS4XUzSt9xrnOPTTQgro6JFZL1M2SiikrZPls/wmK5+o1g3NdJmyVzhxVfTv/v5Hj6IJbePJ79R9WC7BXdx27Zu7slKJ72Db13enJ0RSBLvG/nmZslMgxVB59+9FtFPiKIwVN/+8TLlfFkWq+96+3+u+TxLFsrmlNusTQ9FUj48JAQAAAAAIr3VRjuwnyEfyTu//goFLPpbmeejm6fmozfPQXZfKR3Oeh+4KdD4G8jx0X7jkoz3PQ2+Xfy6a8jx036fnozPPQ6+Rfy625HnozfLPRUeeh75e/rnoyfPQD8g/F0N5HvpS+efifJ6HXib/XLzN89AXyj8XlxbnaIn8AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+H/7FQTvdJ49OD7hAAAAAElFTkSuQmCC',
                        width: 16,
                        margin: [-10, -7, 0, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '40 ํC',
                        margin: [-45, -8, 0, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-10, -7, 0, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '50 ํC',
                        margin: [-45, -8, 0, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-10, -7, 0, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '40 ํC',
                        margin: [-45, -8, 0, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-10, -7, 1, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '\t50 ', //มากกว่าหรือเท่ากับ
                        margin: [-45, -8, -1, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                text: '< 40',
                style: 'headerTable',
                alignment: 'center',
                margin: [-7, -5, 0, -7],
                border: [true, false, true, true],
              },
              {
                text: '< 1.8',
                style: 'headerTable',
                alignment: 'center',
                margin: [-7, -5, 0, -7],
                border: [true, false, true, true],
              },
              {
                table: {
                  widths: ['30%', '70%'],
                  body: [
                    [
                      {
                        image:
                          'data:image/png;base64,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',
                        width: 16,
                        margin: [-10, -7, 0, 0],
                        alignment: 'left',
                        border: [false, false, false, false],
                      },
                      {
                        text: '50 ',
                        margin: [-45, -8, 0, -7],
                        alignment: 'right',
                        style: 'headerTable',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                border: [false, false, true, false],
              },
              {
                text: '< 15%',
                style: 'headerTable',
                alignment: 'center',
                margin: [-7, -5, 0, -7],
                border: [true, false, true, true],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, false, true, true],
              },
              {
                text: '',
                style: 'headerTable',
                border: [true, false, true, true],
              },
            ],
            ...TableBody,
            ...FooterBody,
          ],
        },
      },
      {
        alignment: 'between',
        table: {
          widths: ['35%', '35%', '30%'],
          body: [
            [
              {
                text: 'พนักงานกะ 1  1 ..................................................',
                alignment: 'left',
                style: 'headerTable',
                margin: [0, 0, 0, -2],
                border: [false, false, false, false],
              },
              {
                text: 'พนักงานกะ 2  1 ..................................................',
                style: 'headerTable',
                margin: [0, 0, 0, -2],
                alignment: 'left',
                border: [false, false, false, false],
              },
              { text: '', border: [false, false, false, false] },
            ],
            [
              {
                text: '2 ..................................................',
                alignment: 'left',
                style: 'headerTable',
                margin: [51, 0, 0, -2],
                border: [false, false, false, false],
              },
              {
                text: '2 ..................................................',
                style: 'headerTable',
                margin: [51, 0, 0, -2],
                alignment: 'left',
                border: [false, false, false, false],
              },
              {
                text: '..................................................',
                border: [false, false, false, false],
                style: 'headerTable',
                margin: [0, 0, 0, -2],
              },
            ],
            [
              {
                text: '3 ..................................................',
                alignment: 'left',
                style: 'headerTable',
                margin: [51, 0, 0, -2],
                border: [false, false, false, false],
              },
              {
                text: '3 ..................................................',
                style: 'headerTable',
                margin: [51, 0, 0, -2],
                alignment: 'left',
                border: [false, false, false, false],
              },
              {
                text: 'หัวหน้า แผนกก๊าซชีวภาพ',
                style: 'headerTable',
                margin: [0, 0, 0, -2],
                border: [false, false, false, false],
              },
            ],
          ],
        },
        styles: {
          header: {
            fontSize: 8,
            bold: true,
            alignment: 'right',
          },
          header1: {
            fontSize: 12,
            bold: true,
          },
        },
      },
    ],

    images: {
      logo_imge: system?.logo,
    },
    styles: {
      icon: {
        font: 'FontAwesome',
        bold: true,
        alignment: 'center',
        fontSize: 10,
      },
      header: {
        bold: true,
        fontSize: 14,
        margin: [0, -2, 0, -3],
      },
      header2: {
        fontSize: 16,
      },
      headerTable: {
        margin: [-3, -3, -3, -2],
        fontSize: 13,
        bold: true,
        alignment: 'center',
      },
      tableContent: {
        fontSize: 13,
        margin: [0, -4, 0, -2],
        alignment: 'center',
      },
    },
  }
  pdfMake.createPdf(docDefinition).open()
}
export default FM_BG_002
